export default "__VITE_ASSET__DiF8RWN5__"